import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isMainList, isTomorrowList } from '../constants/listTypes';

export default function Sidebar({ lists, activeListId, onSelectList, onCreateNew, onLogout }) {
  const navigate = useNavigate();
  return (
    <div className="sidebar">
      <div className="sidebar-brand">
        <div className="sidebar-brand-content">
          <img src="/logo_big.png" alt="Windmill" className="sidebar-brand-logo" />
          <div className="sidebar-brand-text">
            <h1 className="sidebar-brand-title">Windmill</h1>
            <p className="sidebar-brand-tagline">Get stuff done</p>
          </div>
        </div>
      </div>
      <div className="sidebar-header">
        <h2 className="sidebar-title">Lists</h2>
        <button
          onClick={onCreateNew}
          className="btn-icon btn-new-list"
          title="Create new list"
          aria-label="Create new list"
        >
          +
        </button>
      </div>

      <nav className="sidebar-nav">
        {lists.map(list => {
          const isMain = isMainList(list.list_type);
          const isTomorrow = isTomorrowList(list.list_type);
          const isActive = list.id === activeListId;
          const openCount = (list.tasks || []).filter(task => !task.completed).length;

          return (
            <button
              key={list.id}
              onClick={() => {
                // Update state immediately for instant UI feedback
                onSelectList(list.id);
                // Navigate to update URL for browser history
                navigate(`/list/${list.id}`);
              }}
              className={`sidebar-item ${isActive ? 'sidebar-item-active' : ''} ${isMain ? 'sidebar-item-main' : ''} ${isTomorrow ? 'sidebar-item-tomorrow' : ''}`}
              aria-label={`View ${list.name} list`}
            >
              <div className="sidebar-item-content">
                <span className="sidebar-item-name">
                  {isTomorrow ? 'To Do Tomorrow' : list.name}
                  {list.is_shared && (
                    <svg 
                      className="shared-icon" 
                      width="14" 
                      height="14" 
                      viewBox="0 0 20 20" 
                      fill="currentColor"
                      title="Shared list"
                    >
                      <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                    </svg>
                  )}
                </span>
                <span className="sidebar-item-count">
                  {openCount}
                </span>
              </div>
            </button>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <button 
          className="sidebar-footer-link" 
          aria-label="Account"
          onClick={() => navigate('/account')}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <circle cx="10" cy="7" r="3" />
            <path d="M3 18c0-3.866 3.134-7 7-7s7 3.134 7 7" />
          </svg>
          <span>Account</span>
        </button>
        <button 
          className="sidebar-footer-link" 
          aria-label="Logout"
          onClick={onLogout}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M13 3h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-3M8 16l-5-5 5-5M3 11h11" />
          </svg>
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
}

